export default "__VITE_ASSET__OTyD$4Gz__"